import styled from 'styled-components';

export const InstructionOutro = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${p => (p.isDesktop ? '2rem' : '1rem 1rem 3.5rem')};
`;

export const TitleText = styled.div`
  font-size: ${p => (p.isDesktop ? 24 : 16)}px;
  font-weight: 600; // semibold
  line-height: ${p => (p.isDesktop ? 32 : 24)}px;
  margin-top: ${p => (p.isDesktop ? 0 : 'auto')};
`;

export const SubtitleText = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: ${p => (p.isDesktop ? 0 : 'auto')};
  margin-top: 16px;
`;
